import { IconButton, Tooltip } from '@mui/material';
import { Create as IconCreate } from '@mui/icons-material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReadonlyProperty } from '../../../../../../Apollo';
import TestIds from 'Tests/TestIds';
import EditPhoneDialog from './EditPhoneDialog';

interface Props {
  readonlyProperties: ReadonlyProperty[];
  person: IPersonWithAccount;
}

interface State {
  isDialogOpen: boolean;
}

class EditPhoneToggle extends React.Component<Props, State> {
  public readonly state: State = {
    isDialogOpen: false
  };

  public render() {
    const { person, readonlyProperties } = this.props;
    const { isDialogOpen } = this.state;

    return <>
      <Tooltip
        title={<FormattedMessage id="common.action.edit" />}
        placement="bottom"
      >
        <IconButton
          data-testid={TestIds.pages.profile.editPhoneButton}
          onClick={this.onOpenDialog}
          size="large">
          <IconCreate />
        </IconButton>
      </Tooltip>
      {isDialogOpen && (
        <EditPhoneDialog
          person={person}
          readonlyProperties={readonlyProperties}
          onClose={this.onCloseDialog}
        />
      )}
    </>;
  }

  private onOpenDialog = () => {
    this.setState({
      isDialogOpen: true
    });
  };

  private onCloseDialog = () => {
    this.setState({
      isDialogOpen: false
    });
  };
}

export default EditPhoneToggle;
